export default __webpack_public_path__ + "static/media/PowerGrotesk-BoldItalic.28f03972.otf";